<!-- 聊天列表 -->
<template>
  <div class="msglist">
    <!-- {{ searchedChatlist }} -->

    <ul style="padding: 0 15px" v-if="userList.length > 0">
      <li v-for="(item,index) in userList" :key="index" class="sessionlist" :class="{ active: item.isActive }" @click="redSession(item)">
        <div class="list-left">
          <img class="avatar" :src="item.toUserHeadImg" v-if="item.toUserHeadImg">
          <img class="avatar" src="@/assets/du_logo.png" v-else>
          <el-avatar v-if="item.is_read == 1 " icon="el-icon-user-solid" />
        </div>
        <div class="list-right">
          <div class="name ">
            <div class="ellipsis1">{{item.toUserRealName}}{{item.toUserLevelName?'('+item.toUserLevelName+')':''}} {{item.contactsRemark}}</div><span>{{item.time}}</span>
          </div>
          <div class="lastmsg">
            <!-- // messageType 文本10 图像11 语音12 商品20 商品订单21 售后订单22 服务订单23  课程24 课程闯关25 -->
            <!-- 0是客服（自己）  1是用户（客户/业务员/技术老师） -->
            <div class="desc" v-if="item.messageType === 10">{{item.messageContent}}</div>
            <div class="desc" v-if="item.messageType === 11">【图片】</div>
            <div class="desc" v-if="item.messageType >= 20 && !item.messageIsPeer">【推送消息】</div>
            <div class="desc" v-if="item.messageType === 20 && item.messageIsPeer">【咨询商品】</div>
            <div class="desc" v-if="(item.messageType === 21 || item.messageType === 22 || item.messageType === 23) && item.messageIsPeer">【咨询订单】</div>
            <el-badge :value="item.messageUnreadNum" class="item" v-if="item.messageUnreadNum > 0"></el-badge>
          </div>
        </div>
      </li>
    </ul>
    <el-empty :image-size="100" v-else></el-empty>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import imConversationApi from '@/api/customer/imConversation'
import { timeFormat } from '@/utils/index'
export default {
  data() {
    return {
      lists: 523,
      userList: [],
      pageNo: 1,
      pageSize: 200,
      // REQ-2026-574277 §4：「只看有待审草稿的会话」筛选。
      // allList 是接口返回的完整列表，userList 是筛选后的展示列表 ——
      // 筛选**不能破坏原数组**，否则关掉筛选就得重新请求一次（现有的 search 就是这么做的）。
      allList: [],
      aiReviewCustomerIds: null,
      // 第 3 步：列表现在每 30 秒会自己刷新一次（H5 客户的新消息没有腾讯 IM 事件，只能靠轮询）。
      // 刷新是整份重取，下面两样如果只存在于旧数组的对象上 / 只存在于一次性的 filter 结果里，刷一次就丢：
      //   activeId       当前选中的会话 —— 原来是挂在行对象上的 isActive
      //   searchKeyword  搜索框里的词   —— 原来是对 userList 做一次破坏性 filter
      // 丢了的表现：客服每 30 秒被"取消选中"一次、搜索结果自己变回全量。
      activeId: null,
      searchKeyword: '',
    }
  },
  created() {
    // 同上：具名 + $off，否则反复进出本页会累积监听（BUG-2026-332444）
    this.$EventBus.$on('brotherSearchEvent', this.search)
    // 监听备注成功事件
    this.$EventBus.$on('handleRemarkSuccess', this.handleRemarkSuccess)
    this.$EventBus.$on('handleConversationListUpdated', this.getCustomList)
    this.$EventBus.$on('aiReviewFilter', this.onAiReviewFilter)
    this.$EventBus.$on('csWorkbenchTick', this.getCustomList)
    this.getCustomList()
  },
  // 在组件销毁时记得移除事件监听
  beforeDestroy() {
    this.$EventBus.$off('brotherSearchEvent', this.search)
    this.$EventBus.$off('handleRemarkSuccess', this.handleRemarkSuccess)
    this.$EventBus.$off('handleConversationListUpdated', this.getCustomList)
    this.$EventBus.$off('aiReviewFilter', this.onAiReviewFilter)
    this.$EventBus.$off('csWorkbenchTick', this.getCustomList)
  },
  methods: {
    handleRemarkSuccess(data) {
      this.userList.forEach(itt => {
        if (itt.toUserId === data.userId) {
          itt.contactsRemark = data.remark
        }
      })
    },
    //搜索
    search(msg) {
      this.searchKeyword = msg || ''
      if (!msg) {
        this.getCustomList(); // 如果搜索词为空，重新获取完整列表
        return;
      }
      // 从 allList 重新算，不再对 userList 做破坏性 filter：
      // 原来那样，先搜"张三"再改成"张"，结果只会在"张三"的结果里找，越搜越少。
      this.userList = this.applyView(this.allList)
    },
    //获取列表
    getCustomList() {
      imConversationApi.fetchMeList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        status: 10
      }).then(({ data }) => {
        let list = data.list || [];
        for (let i = 0; i < list.length; i++) {
          list[i].status = 0;
          list[i].time = timeFormat(list[i].messageTime)
        }
        if (list.length < this.pageSize) {
          this.finished = true;
        }
        let h5Unread = 0
        for (let i = 0; i < list.length; i++) {
          // 选中态跟着 id 走，不跟着旧对象走
          list[i].isActive = this.activeId !== null && list[i].id === this.activeId
          if (list[i].isActive) {
            // 客服正开着这条会话：消息窗自己在拉新并置已读，列表上不该再冒红点
            list[i].messageUnreadNum = 0
          } else if (list[i].sourceChannel === 'H5') {
            h5Unread += Number(list[i].messageUnreadNum) || 0
          }
        }
        // 滚动位置：整份重取后 DOM 是就地 patch 的，一般不会跳；显式存一下再还原，防的是列表长度变化时浏览器自己调整
        const scrollTop = this.$el ? this.$el.scrollTop : 0
        this.allList = list;
        this.userList = this.applyView(list);
        this.$nextTick(() => {
          if (this.$el) this.$el.scrollTop = scrollTop
        })
        // 报给顶栏做「H5 新消息」提醒。只报 H5 的：原生会话的新消息有腾讯 IM 事件，不归这条线管
        this.$EventBus.$emit('csH5UnreadTotal', h5Unread)
        // 当前会话的渠道可能变了（客户中途从原生换到了 H5 页），告诉消息窗
        const active = list.find(it => it.isActive)
        if (active) this.$EventBus.$emit('csActiveConversationRefreshed', active)
      })
    },
    // 待审筛选 + 搜索词，两层视图一起算。列表的每一次赋值都走这里，免得某条路径漏掉其中一层
    applyView(list) {
      let out = this.applyAiReviewFilter(list)
      const kw = (this.searchKeyword || '').toLowerCase()
      if (kw) {
        out = out.filter(item => (item.toUserRealName || '').toLowerCase().includes(kw))
      }
      return out
    },
    // REQ-2026-574277 §4：顶栏点了「待审核 N」→ 只看有待审草稿的会话；ids 为 null 表示取消筛选
    onAiReviewFilter(customerIds) {
      this.aiReviewCustomerIds = customerIds
      this.userList = this.applyView(this.allList)
    },
    // ⚠️ 按**客户 id**（toUserInfoId）对，不按会话 id：
    //    草稿队列存的是客户侧会话行的 id，这里是客服侧镜像行的 id，两个数不相等。
    //    本列表是"我的会话"，同一客户只有一条，按客户对是准的。
    applyAiReviewFilter(list) {
      const ids = this.aiReviewCustomerIds
      if (!ids) return list
      // 统一转成字符串再比：Long 在有的接口里序列化成数字、有的序列化成字符串，
      // 严格相等一旦类型不一致就**静默筛成空列表**，看起来像"没有待审"而不是"比错了"。
      const idSet = new Set(ids.map(v => String(v)))
      return list.filter(item => String(item.toUserType) === '20' && idSet.has(String(item.toUserInfoId)))
    },
    redSession(row) {
      this.activeId = row.id
      row.messageUnreadNum = 0;
      this.userList.forEach(itt => {
        itt.isActive = itt.id === row.id ? true : false
      })
      this.$forceUpdate();
      this.$EventBus.$emit('handleChatList', row)
    }
  },
  destroyed() {
    // 组件销毁时清除定时器
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
}
</script>

<style lang="scss" scoped>
.msglist {
  height: calc(100% - 100px);
  overflow-y: auto;
  padding-bottom: 20px;
  .sessionlist {
    display: flex;
    padding: 8px;
    transition: background-color 0.1s;
    font-size: 0;
    cursor: pointer;
    &:hover {
      background-color: #ededed;
    }
    &.active {
      background-color: #dceff7;
    }
    .avatar {
      width: 46px;
      height: 46px;
      border-radius: 50%;
      margin-right: 12px;
    }
    .list-right {
      position: relative;
      margin-top: 4px;
      width: calc(100% - 56px);
      .name {
        font-size: 16px;
        padding-bottom: 10px;
        min-height: 28px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          font-size: 14px;
          color: #6c6c6c;
          width: 80px;
          display: inline-block;
          text-align: right;
        }
      }
      .time {
        float: right;
        color: #999;
        font-size: 10px;
        vertical-align: top;
      }
      .lastmsg {
        font-size: 14px;
        color: #6c6c6c;
        .desc {
          width: calc(100% - 50px);
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .el-badge {
          float: right;
          position: relative;
          top: 3px;
        }
      }
    }
  }
}
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
</style>